import { Outlet, createFileRoute } from '@tanstack/react-router'
import { MODEL_REGISTRY_MODULE_ID } from '@/features/model-registry'
import { requirePermission } from '@/shared/auth'
import { requireModule } from '@/shared/modules'

export const Route = createFileRoute('/app/model-registry')({
  beforeLoad: (args) => {
    requireModule(MODEL_REGISTRY_MODULE_ID)(args)
    return requirePermission('model-registry:view')(args)
  },
  component: Outlet,
})
